import OrbitApiV1 from '.'

class SimAPI {
  static getSimsFromOrder(orderNo) {
    return OrbitApiV1.httpGet(`/sim/${orderNo}`)
  }

  static updateSim(simDetails) {
    return OrbitApiV1.httpPost(`/sim/update`, {}, simDetails)
  }

  static deleteSim(msisdnList) {
    return OrbitApiV1.httpDelete(`/sim/msisdn?list=${msisdnList}`)
  }


}

export default SimAPI
